import { EffectFade } from "swiper";
import Swiper, { SwiperSlide } from "../../components/swiper";
import HeroSliderThreeSingle from "../../components/hero-slider/HeroSliderThreeSingle.js";
import React, { useEffect, useState } from "react";
import { IHomePageSlider, Slide } from "../../shared/commonUtils";
const params = {
  //  effect?: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' | 'creative' | 'cards';
  effect: "fade",
  // fadeEffect: {
  //   crossFade: true,
  // },
  autoplay: true,
  modules: [EffectFade],
  loop: false,
  speed: 1000,
  pagination: true,
  // dir: "rtl",
  navigation: false,
  autoHeight: false,
};
interface IHeroSliderThree {
  homePageSlider: Slide[];
}
const HeroSliderThree: React.FC<IHeroSliderThree> = (
  props: IHeroSliderThree
) => {
  const [loading, setLoading] = useState<boolean>(true);
  const { homePageSlider } = props;
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, []);
  // Utility function to check if image is valid
  const isValidImage = (imageUrl) => {
    return (
      imageUrl && imageUrl !== "" && imageUrl !== null && imageUrl !== undefined
    );
  };
  return (
    <>
      {homePageSlider && (
        <div
          style={{ background: "var(--slider-background-color)" }}
          className="slider-area"
        >
          <div className="slider-active nav-style-1">
            <Swiper options={params}>
              {homePageSlider
                ?.filter((single) => {
                  const isMobile = window.innerWidth <= 700;
                  return isMobile
                    ? isValidImage(single.mobile_image)
                    : isValidImage(single.image);
                })
                .map((single, key) => (
                  <SwiperSlide key={key}>
                    <HeroSliderThreeSingle data={single} />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
};

export default HeroSliderThree;
